// ---------------------------------------------------------------------------
// Shared shape types – import these downstream instead of repeating inline
// ---------------------------------------------------------------------------

/** `{ text, value }` shape used by GROUP_TYPE_* and similar option constants. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export type GroupType = { readonly text: string; readonly value: string }

/** `{ value, text }` shape used by COHORT_USER_STATUS_* constants. */
export type CohortUserStatus = { readonly value: string; readonly text: string }

/** `{ text, value }` shape used by DAYS_OF_THE_WEEK. */
export type DayOfWeekOption = { readonly text: string; readonly value: string }

/** Full timezone descriptor used by EASTERN_TIME etc. and TIME_ZONES. */
export type TimeZone = {
  readonly value: string
  readonly text: string
  readonly shortText: string
}

/** Search filter descriptor with optional URL param. */
export type SearchFilter = {
  readonly text: string
  readonly type: string
  readonly urlParam?: string
}

/** US state descriptor used by STATES_OF_USA. */
export type StateOption = { readonly state: string; readonly abbreviation: string }

/** Credential role descriptor used by CREDENTIAL_PROFESSIONAL_ROLES. */
export type CredentialRole = {
  readonly shortDisplay: string
  readonly shortEnum: string
  readonly long: string
}

// ---------------------------------------------------------------------------

type RuntimeEnv = "production" | "development"

const env: RuntimeEnv =
  process.env.NEXT_PUBLIC_ENV === "production" ? "production" : "development"

export const AUTH_ROLE_ZEST_ADMIN = "zest_admin"
export const AUTH_ROLE_ZEST_PROVIDER = "zest_provider"
export const AUTH_ROLE_ZEST_USER = "zest_client"

export const JWT_TOKEN = "jwt_token"

export const CREATE_GROUP_SNAPSHOT_SECTION = "Snapshot"
export const CREATE_GROUP_DEEP_DIVE_SECTION = "Deep Dive"
export const CREATE_GROUP_LEADERSHIP_SECTION = "Leadership"
export const CREATE_GROUP_LOGISTICS_SECTION = "Logistics"

export const GROUP_CONFIG_RECRUITING_PHASE = "RECRUITING_PHASE"

export const LOCATION_VIRTUAL = "Virtually"
export const LOCATION_IN_PERSON = "In-person"
export const LOCATION_HYBRID = "Hybrid"

// zest.location_setting enum values (group.locationSetting in GraphQL)
export const LOCATION_SETTING_VIRTUAL = "VIRTUAL"
export const LOCATION_SETTING_IN_PERSON = "IN_PERSON"
export const LOCATION_SETTING_HYBRID = "HYBRID"

export const REQUIRED_TO_RESIDE_ANYWHERE = "Anywhere"
export const REQUIRED_TO_SPECIFIC_STATE = "Add state"

export const DURATION_ENDS = "Ends"
export const DURATION_INDEFINITE = "Indefinite"

export const STRUCTURE_OPEN = "Doors Stay Open"
export const STRUCTURE_CLOSED = "Doors Close"

export const STAGE_RUNNING = "Yes"
export const STAGE_NOT_RUNNING = "No"

export const SCHEDULE_REPEATS = "Repeats"
export const SCHEDULE_SPECIFIC_DATES = "Specific Dates"

export const SAME_TIME_EACH_DAY = "Same time for each day"
export const DIFFERENT_TIME_EACH_DAY = "Days have different times"

export const SNAPSHOT_SCREENS = 4
export const DEEP_DIVE_SCREENS = 4
export const LEADERSHIP_SCREENS = 2
export const LOGISTICS_SCREENS = 1

export const GROUP_TYPE_SUPPORT_GROUP: GroupType = {
  text: "Support Group",
  value: "SUPPORT_GROUP",
}
export const GROUP_TYPE_THERAPY_GROUP: GroupType = {
  text: "Therapy Group",
  value: "THERAPY_GROUP",
}
export const GROUP_TYPE_WORKSHOP: GroupType = { text: "Workshop", value: "WORKSHOP" }
export const GROUP_TYPE_RETREAT: GroupType = { text: "Retreat", value: "RETREAT" }
export const GROUP_TYPE_CLINICAL_PEER_GROUP: GroupType = {
  text: "Clinical Peer Group",
  value: "PROVIDER_GROUP",
}
export const GROUP_TYPES: GroupType[] = [
  GROUP_TYPE_SUPPORT_GROUP,
  GROUP_TYPE_THERAPY_GROUP,
  GROUP_TYPE_WORKSHOP,
  GROUP_TYPE_RETREAT,
  GROUP_TYPE_CLINICAL_PEER_GROUP,
]

export const JOIN_REQUIREMENT_CONSULTATION_REQUIRED = "CONSULTATION_REQUIRED"

export const NO_CONSULTATION_REQUIRED = "No Consultation Required"
export const CONSULTATION_REQUIRED = "Consultation Required"

export const LICENSED = "Licensed"
export const UNLICENSED = "Unlicensed"

export const GROUP_DESCRIPTION_PEOPLE = "PEOPLE_DESCRIPTION"
export const GROUP_DESCRIPTION_EXPECTATION = "EXPECTATION_DESCRIPTION"
export const GROUP_DESCRIPTION_YOU = "YOU_DESCRIPTION"
export const GROUP_DESCRIPTION_FEATURE_GROUP_IN_NEWSLETTER =
  "FEATURE_GROUP_IN_NEWSLETTER_DESCRIPTION"

export const COHORT_LOCATION = "LOCATION"
export const COHORT_LOCATION_IN_PERSON_OR_VIRTUAL = "IN_PERSON_OR_VIRTUAL"
export const COHORT_LOCATION_IS_REQUIRED_TO_RESIDE_ANYWHERE_STATUS =
  "IS_REQUIRED_TO_RESIDE_ANYWHERE_STATUS"
export const COHORT_LOCATION_STATES_REQUIRED_TO_RESIDE = "STATES_REQUIRED_TO_RESIDE"

export const LOCATION_VIRTUAL_ONLINE_DIRECTIONS = "ONLINE_DIRECTIONS"
export const LOCATION_VIRTUAL_ONLINE_URL = "ONLINE_URL"

export const LOCATION_ADDRESS_LINE_1 = "LINE_1"
export const LOCATION_ADDRESS_LINE_2 = "LINE_2"
export const LOCATION_ADDRESS_CITY = "CITY"
export const LOCATION_ADDRESS_STATE = "STATE"
export const LOCATION_ADDRESS_ZIP_CODE = "ZIP_CODE"
export const LOCATION_ADDRESS_LATITUDE = "LATITUDE"
export const LOCATION_ADDRESS_LONGITUDE = "LONGITUDE"
export const LOCATION_ADDRESS_PLACE_ID = "PLACE_ID"
export const LOCATION_ADDRESS_PLACE = "PLACE"
export const LOCATION_ADDRESS_DIRECTIONS = "DIRECTIONS"

export const COHORT_DURATION = "DURATION"
export const COHORT_DURATION_ENDS_OR_IS_INDEFINITE = "ENDS_OR_IS_INDEFINITE"
export const COHORT_STRUCTURE = "STRUCTURE"
export const COHORT_STRUCTURE_IS_OPEN_OR_CLOSED_DOORS = "IS_OPEN_OR_CLOSED_DOORS"
export const COHORT_STAGE = "STAGE"
export const COHORT_STAGE_IS_RUNNING = "IS_RUNNING"
export const COHORT_SIZE = "SIZE"
export const COHORT_SIZE_CURRENT_NUMBER_OF_MEMBERS = "CURRENT_NUMBER_OF_MEMBERS"
export const COHORT_SIZE_MAX_NUMBER_OF_MEMBERS = "MAX_NUMBER_OF_MEMBERS"
export const COHORT_SIZE_MIN_NUMBER_OF_MEMBERS = "MIN_NUMBER_OF_MEMBERS"
export const COHORT_PAYMENT = "PAYMENT"
export const COHORT_PAYMENT_WHO_HANDLES_PAYMENT_AND_WHEN =
  "WHO_HANDLES_PAYMENT_AND_WHEN"
export const COHORT_PRICE = "PRICE"
export const COHORT_PRICE_PER_CLIENT_PER_SESSION = "PER_CLIENT_PER_SESSION"
export const COHORT_CANCELATION_POLICY = "POLICY"
export const COHORT_CANCELATION_POLICY_HOURS = "HOURS"
export const COHORT_CANCELATION_POLICY_PERCENT = "PERCENT"
export const COHORT_DATE_AND_TIME = "COHORT_DATE_AND_TIME"
export const COHORT_DATE_AND_TIME_SELECTED_DISCRETE_DATES = "SELECTED_DISCRETE_DATES"
export const COHORT_WELCOME_SCREEN = "COHORT_WELCOME_SCREEN"
export const COHORT_WELCOME_SCREEN_MESSAGE = "COHORT_WELCOME_SCREEN_MESSAGE"

export const COHORT_SCHEDULE_EXACT = "exact"
export const COHORT_SCHEDULE_EXACT_DATE = "date"
export const COHORT_SCHEDULE_EXACT_STARTS_AT = "starts_at"
export const COHORT_SCHEDULE_EXACT_ENDS_AT = "ends_at"

export const COHORT_SCHEDULE_RECURRING = "recurring"
export const COHORT_SCHEDULE_RECURRING_WINDOW = "window"
export const COHORT_SCHEDULE_RECURRING_WINDOWS_PER_RECURRENCE =
  "windows_per_recurrence"
export const COHORT_SCHEDULE_RECURRING_START_DATE = "start_date"
export const COHORT_SCHEDULE_RECURRING_END_DATE = "end_date"
export const COHORT_SCHEDULE_RECURRING_ITEMS = "items"
export const COHORT_SCHEDULE_RECURRING_ITEMS_DAY = "day"
export const COHORT_SCHEDULE_RECURRING_ITEMS_STARTS_AT = "starts_at"
export const COHORT_SCHEDULE_RECURRING_ITEMS_ENDS_AT = "ends_at"

export const COHORT_SCHEDULE_TIMEZONE = "timezone"

export const INDEFINITE_SESSSIONS_NOT_CURRENTLY_RUNNING =
  "INDEFINITE_SESSSIONS_NOT_CURRENTLY_RUNNING"
export const INDEFINITE_SESSIONS_CURRENTLY_RUNNING =
  "INDEFINITE_SESSIONS_CURRENTLY_RUNNING"
export const DEFINITE_SESSIONS_PERIODIC = "DEFINITE_SESSIONS_PERIODIC"
export const DEFINITE_SESSIONS_PARTICULAR = "DEFINITE_SESSIONS_PARTICULAR"

export const GROUP_PRE_REQUISITE = "GROUP_PRE_REQUISITE"
export const GROUP_PRE_REQUISITE_NONE = "No pre-requistes required"
export const GROUP_PRE_REQUISITE_CONSULTATION = "Consultation required"
export const GROUP_PRE_REQUISITE_SET = "PRE_REQUISITE_SET"
export const GROUP_LICENSURE_SET = "LICENSURE_SET"

export const COHORT_LOCATION_SCREEN = "location"
export const COHORT_DURATION_SCREEN = "duration"
export const COHORT_STRUCTURE_SCREEN = "structure"
export const COHORT_STAGE_SCREEN = "stage"
export const COHORT_SIZE_SCREEN = "size"
export const COHORT_PAYMENT_SCREEN = "payment"
export const COHORT_PRICING_SCREEN = "pricing"
export const COHORT_DATES_AND_TIMES_SCREEN = "dates_and_times"
export const COHORT_CANCELATION_POLICY_SCREEN = "cancelation_policy"

export const CONSULT_SCREEN_INHERITED = "CONSULT_SCREEN_INHERITED"
export const WELCOME_MESSAGE_INHERITED = "WELCOME_MESSAGE_INHERITED"
export const LOCATION_INHERITED = "LOCATION_INHERITED"
export const LOCATION_SCREEN_INHERITED = "LOCATION_SCREEN_INHERITED"
export const DURATION_SCREEN_INHERITED = "DURATION_SCREEN_INHERITED"
export const DATES_AND_TIME_SCREEN_INHERITED = "DATES_AND_TIME_SCREEN_INHERITED"
export const STRUCTURE_SCREEN_INHERITED = "STRUCTURE_SCREEN_INHERITED"
export const STAGE_SCREEN_INHERITED = "STAGE_SCREEN_INHERITED"
export const SIZE_SCREEN_INHERITED = "SIZE_SCREEN_INHERITED"
export const PAYMENT_SCREEN_INHERITED = "PAYMENT_SCREEN_INHERITED"
export const PRICING_SCREEN_INHERITED = "PRICING_SCREEN_INHERITED"
export const CANCELATION_POLICY_SCREEN_INHERITED =
  "CANCELATION_POLICY_SCREEN_INHERITED"

export const PHOTO_CROPPER_SHAPE_RECTANGLE = "Rectangle"
export const PHOTO_CROPPER_SHAPE_SQUARE = "Square"
export const PHOTO_CROPPER_SHAPE_CIRCLE = "Circle"

export const STATES_OF_USA = [
  { state: "Alabama", abbreviation: "AL" },
  { state: "Alaska", abbreviation: "AK" },
  { state: "Arizona", abbreviation: "AZ" },
  { state: "Arkansas", abbreviation: "AR" },
  { state: "California", abbreviation: "CA" },
  { state: "Colorado", abbreviation: "CO" },
  { state: "Connecticut", abbreviation: "CT" },
  { state: "Delaware", abbreviation: "DE" },
  { state: "District of Columbia", abbreviation: "DC" },
  { state: "Florida", abbreviation: "FL" },
  { state: "Georgia", abbreviation: "GA" },
  { state: "Hawaii", abbreviation: "HI" },
  { state: "Idaho", abbreviation: "ID" },
  { state: "Illinois", abbreviation: "IL" },
  { state: "Indiana", abbreviation: "IN" },
  { state: "Iowa", abbreviation: "IA" },
  { state: "Kansas", abbreviation: "KS" },
  { state: "Kentucky", abbreviation: "KY" },
  { state: "Louisiana", abbreviation: "LA" },
  { state: "Maine", abbreviation: "ME" },
  { state: "Maryland", abbreviation: "MD" },
  { state: "Massachusetts", abbreviation: "MA" },
  { state: "Michigan", abbreviation: "MI" },
  { state: "Minnesota", abbreviation: "MN" },
  { state: "Mississippi", abbreviation: "MS" },
  { state: "Missouri", abbreviation: "MO" },
  { state: "Montana", abbreviation: "MT" },
  { state: "Nebraska", abbreviation: "NE" },
  { state: "Nevada", abbreviation: "NV" },
  { state: "New Hampshire", abbreviation: "NH" },
  { state: "New Jersey", abbreviation: "NJ" },
  { state: "New Mexico", abbreviation: "NM" },
  { state: "New York", abbreviation: "NY" },
  { state: "North Carolina", abbreviation: "NC" },
  { state: "North Dakota", abbreviation: "ND" },
  { state: "Northern Mariana Islands", abbreviation: "MP" },
  { state: "Ohio", abbreviation: "OH" },
  { state: "Oklahoma", abbreviation: "OK" },
  { state: "Oregon", abbreviation: "OR" },
  { state: "Pennsylvania", abbreviation: "PA" },
  { state: "Rhode Island", abbreviation: "RI" },
  { state: "South Carolina", abbreviation: "SC" },
  { state: "South Dakota", abbreviation: "SD" },
  { state: "Tennessee", abbreviation: "TN" },
  { state: "Texas", abbreviation: "TX" },
  { state: "Utah", abbreviation: "UT" },
  { state: "Vermont", abbreviation: "VT" },
  { state: "Virginia", abbreviation: "VA" },
  { state: "Washington", abbreviation: "WA" },
  { state: "West Virginia", abbreviation: "WV" },
  { state: "Wisconsin", abbreviation: "WI" },
  { state: "Wyoming", abbreviation: "WY" },
] as const satisfies readonly StateOption[]

/** Two-letter GraphQL `UsState` value used at API/storage boundaries. */
export type UsStateCode = (typeof STATES_OF_USA)[number]["abbreviation"]

/** Human-readable state name used only for display. */
export type UsStateName = (typeof STATES_OF_USA)[number]["state"]

export const US_STATES = STATES_OF_USA.map((s) => s.state)

/** Legacy provider profileContent key retained only for privacy scrubbing/migration. */
export const PROFILE_NEWSLETTER_NOTIFY_ALL_PSYPACT = "newsletterNotifyAllPsyPact"

export const CREDENTIAL_PROFESSIONAL_LICENSE = "Professional License"
export const CREDENTIAL_PROFESSIONAL_PRE_LICENSE = "Professional Pre-License"
export const CREDENTIAL_CERTIFICATE = "Certificate"
export const CREDENTIAL_DEGREE_DIPLOMA = "Degree or Diploma"
export const CREDENTIAL_MEMBERSHIP = "Membership"
export const CREDENTIAL_PASSED_EXAM = "Passed Exam"

export const CREDENTIAL_PROFESSIONAL_ROLES: CredentialRole[] = [
  {
    shortDisplay: "APRN",
    shortEnum: "APRN",
    long: "Advanced Practice Registered Nurse",
  },
  {
    shortDisplay: "ACSW",
    shortEnum: "ACSW",
    long: "Associate Clinical Social Worker",
  },
  {
    shortDisplay: "AMFT",
    shortEnum: "AMFT",
    long: "Associate Marriage and Family Therapist",
  },
  {
    shortDisplay: "APCC",
    shortEnum: "APCC",
    long: "Associate Professional Clinical Counselor",
  },
  {
    shortDisplay: "BCaBA",
    shortEnum: "BCA_BA",
    long: "Board-Certified Assistant Behavior Analyst",
  },
  {
    shortDisplay: "BCBA",
    shortEnum: "BCBA",
    long: "Board-Certified Behavior Analyst",
  },
  {
    shortDisplay: "CADC",
    shortEnum: "CADC",
    long: "Certified Alcohol and Drug Counselor",
  },
  {
    shortDisplay: "CRC",
    shortEnum: "CRC",
    long: "Certified Rehabilitation Counselor",
  },
  {
    shortDisplay: "CSW",
    shortEnum: "CSW",
    long: "Certified Social Worker",
  },
  {
    shortDisplay: "EdD",
    shortEnum: "ED_D",
    long: "Doctor of Education",
  },
  {
    shortDisplay: "DO",
    shortEnum: "DO",
    long: "Doctor of Osteopathic Medicine",
  },
  {
    shortDisplay: "PsyD",
    shortEnum: "PSY_D",
    long: "Doctor of Psychology",
  },
  {
    shortDisplay: "HSPP",
    shortEnum: "HSPP",
    long: "Health Service Psychologist",
  },
  {
    shortDisplay: "LADC",
    shortEnum: "LADC",
    long: "Licensed Alcohol and Drug Counselor",
  },
  {
    shortDisplay: "LAMFT",
    shortEnum: "LAMFT",
    long: "Licensed Associate Marriage and Family Therapist",
  },
  {
    shortDisplay: "LAMC",
    shortEnum: "LAMC",
    long: "Licensed Associate Mental Health Counselor",
  },
  {
    shortDisplay: "LCPAT",
    shortEnum: "LCPAT",
    long: "Licensed Clinical Professional Art Therapist",
  },
  {
    shortDisplay: "LCPC",
    shortEnum: "LCPC",
    long: "Licensed Clinical Professional Counselor",
  },
  {
    shortDisplay: "LCSW",
    shortEnum: "LCSW",
    long: "Licensed Clinical Social Worker",
  },
  {
    shortDisplay: "LCAT",
    shortEnum: "LCAT",
    long: "Licensed Creative Arts Therapist",
  },
  {
    shortDisplay: "LGPC",
    shortEnum: "LGPC",
    long: "Licensed Graduate Professional Counselor",
  },
  {
    shortDisplay: "LISW",
    shortEnum: "LISW",
    long: "Licensed Independent Social Worker",
  },
  {
    shortDisplay: "LMFT",
    shortEnum: "LMFT",
    long: "Licensed Marriage and Family Therapist",
  },
  {
    shortDisplay: "LMSW",
    shortEnum: "LMSW",
    long: "Licensed Master Social Worker",
  },
  {
    shortDisplay: "LMHC",
    shortEnum: "LMHC",
    long: "Licensed Mental Health Counselor",
  },
  {
    shortDisplay: "LMHP",
    shortEnum: "LMHP",
    long: "Licensed Mental Health Practitioner",
  },
  {
    shortDisplay: "LPCC",
    shortEnum: "LPCC",
    long: "Licensed Professional Clinical Counselor",
  },
  {
    shortDisplay: "LPC",
    shortEnum: "LPC",
    long: "Licensed Professional Counselor",
  },
  {
    shortDisplay: "LPC-AT",
    shortEnum: "LPC_AT",
    long: "Licensed Professional Counselor - Art Therapist",
  },
  {
    shortDisplay: "Psychologist",
    shortEnum: "PSYCHOLOGIST",
    long: "Licensed Psychologist",
  },
  {
    shortDisplay: "LSW",
    shortEnum: "LSW",
    long: "Licensed Social Worker",
  },
  {
    shortDisplay: "MFT",
    shortEnum: "MFT",
    long: "Marriage and Family Therapist",
  },
  {
    shortDisplay: "MSW",
    shortEnum: "MSW",
    long: "Master of Social Work",
  },
  {
    shortDisplay: "MD",
    shortEnum: "MD",
    long: "Medical Doctor",
  },
  {
    shortDisplay: "NCC",
    shortEnum: "NCC",
    long: "National Certified Counselor",
  },
  {
    shortDisplay: "NCSP",
    shortEnum: "NCSP",
    long: "Nationally Certified School Psychologist",
  },
  {
    shortDisplay: "School Counselor",
    shortEnum: "SCHOOL_COUNSELOR",
    long: "School Counselor",
  },
  {
    shortDisplay: "NP",
    shortEnum: "NP",
    long: "Nurse Practitioner",
  },
  {
    shortDisplay: "PA-C",
    shortEnum: "PA_C",
    long: "Physician Assistant – Certified",
  },
  {
    shortDisplay: "PLPC",
    shortEnum: "PLPC",
    long: "Provisional Licensed Professional Counselor",
  },
  {
    shortDisplay: "PMHNP",
    shortEnum: "PMHNP",
    long: "Psychiatric-Mental Health Nurse Practitioner",
  },
  {
    shortDisplay: "Psychiatrist",
    shortEnum: "PSYCHIATRIST",
    long: "Psychiatrist",
  },
  {
    shortDisplay: "QMHP",
    shortEnum: "QMHP",
    long: "Qualified Mental Health Professional",
  },
  {
    shortDisplay: "RCSWI",
    shortEnum: "RCSWI",
    long: "Registered Clinical Social Work Intern",
  },
  {
    shortDisplay: "Other",
    shortEnum: "OTHER",
    long: "Other",
  },
]

export const CREDENTIAL_COACH_EDUCATOR = [
  "Academic",
  "Art",
  "Anger Management",
  "Anxiety",
  "Athletic",
  "Appearance",
  "Assertiveness",
  "Autism",
  "Budgeting",
  "Behavior Management",
  "Business",
  "Career",
  "College Readiness",
  "Coping Skills",
  "Creativity",
  "Communication",
  "Diversity",
  "Divorce",
  "Decluttering",
  "Eating",
  "Elder care",
  "Emotion Regulation",
  "Executive",
  "Executive Functioning",
  "Empowerment",
  "Family",
  "Fashion",
  "Finance",
  "Fitness",
  "Gender",
  "Grief",
  "Health",
  "Intuition",
  "Learning Disabilities",
  "Life",
  "Maternity",
  "Meditation",
  "Mindfulness",
  "Multicultural",
  "Parenting",
  "Popular Education",
  "Pregnancy",
  "Purpose",
  "Relationship",
  "Social Skills",
  "Social Justice",
  "Sports Performance",
  "School",
  "Sex",
  "Sexuality",
  "Self-Care",
  "Stress Management",
  "Substance Use",
  "Teens",
  "Trauma",
  "Yoga",
  "Writing",
  "Other",
]

export const CREDENTIAL_ALTERNATIVE_GROUPING_ALTERNATIVE_MEDICINE_PRACTITIONER =
  "Alternative Medicine Practitioner"
export const CREDENTIAL_ALTERNATIVE_GROUPING_BODY_WORKER = "Body Worker"
export const CREDENTIAL_ALTERNATIVE_GROUPING_DOULA_WORK = "Doula Work"
export const CREDENTIAL_ALTERNATIVE_GROUPING_ENERGY_WORK = "Energy Work"
export const CREDENTIAL_ALTERNATIVE_GROUPING_ESOTERIC_AND_INTUITIVE_WORK =
  "Esoteric & intuitive Work"
export const CREDENTIAL_ALTERNATIVE_GROUPING_RITUAL_AND_SPIRITUAL_WORK =
  "Ritual & Spiritual Work"

export const CREDENTIAL_ALTERNATIVE = {
  [CREDENTIAL_ALTERNATIVE_GROUPING_ALTERNATIVE_MEDICINE_PRACTITIONER]: [
    "Ayurvedic Medicine Practitioner",
    "Herbalist",
    "Homeopath",
    "Natural Medicine Practitioner",
    "Naturopath",
    "Traditional Chinese Medicine Practitioner",
    "Other",
  ],
  [CREDENTIAL_ALTERNATIVE_GROUPING_BODY_WORKER]: [
    "Acupressurist",
    "Acupuncturist",
    "Cupping Body Worker",
    "Massage Therapist",
    "Myofascial Body Worker",
    "Reflexologist",
    "Thai Massage Body Worker",
    "Yoga Teacher",
    "Other",
  ],
  [CREDENTIAL_ALTERNATIVE_GROUPING_DOULA_WORK]: [
    "Abortion Doula",
    "Birth Doula",
    "Death Doula",
    "Journey/Ceremony Guide",
    "Midwife",
    "Other",
  ],
  [CREDENTIAL_ALTERNATIVE_GROUPING_ENERGY_WORK]: [
    "Aromatherapy Practitioner",
    "Biofield Practitioner",
    "Chakra Balancing Energy Worker",
    "Craniosacral Practitioner",
    "Crystal Energy Healing Worker",
    "Electromagnetic Practitioner",
    "Reiki Practitioner",
    "Rolfing Practitioner",
    "Sound Healing Practitioner",
    "Other",
  ],
  [CREDENTIAL_ALTERNATIVE_GROUPING_ESOTERIC_AND_INTUITIVE_WORK]: [
    "Animal communicator",
    "Astrologist",
    "Clairvoyant",
    "Coffee Reader",
    "Hypnotherapist",
    "Numerologist",
    "Palm Reader",
    "Past Life Regression Practitioner",
    "Psychic",
    "Tarot Reader",
    "Tea Reader",
    "Other",
  ],
  [CREDENTIAL_ALTERNATIVE_GROUPING_RITUAL_AND_SPIRITUAL_WORK]: [
    "Brujeria",
    "Candomble",
    "Celebrant",
    "Chaplain",
    "Curandera",
    "Ifa/Babaalawo",
    "Imam",
    "Kohanot",
    "Limpia",
    "Orishas",
    "Rabbi",
    "Shango",
    "Siddha",
    "Sweat Lodges",
    "Umbanda",
    "Yemaya",
    "Other",
  ],
}

export const PROFILE_IMPORT = "PROFILE_IMPORT"
export const PROFILE_IMPORT_LICENSE_NUMBER = "LICENSE_NUMBER"
export const PROFILE_IMPORT_LICENSE_STATE = "LICENSE_STATE"
export const PROFILE_IMPORT_LICENSE_TYPE = "LICENSE_TYPE"
export const PROFILE_IMPORT_EXTERNAL_PROFILE_URL = "EXTERNAL_PROFILE_URL"

export const PROFILE_BASICS = "PROFILE_BASICS"
export const PROFILE_WORK_CONTACT = "PROFILE_WORK_CONTACT"
export const PROFILE_CREDENTIALS = "PROFILE_CREDENTIALS"
export const PROFILE_ROLES = "PROFILE_ROLES"
export const PROFILE_MODALITIES = "PROFILE_MODALITIES"
export const PROFILE_PERSONALITIY = "PROFILE_PERSONALITIY"
export const PROFILE_PHOTO = "PROFILE_PHOTO"
export const PROFILE_YOUR_STORY = "PROFILE_YOUR_STORY"
export const PROFILE_LIVED_EXPERIENCE = "PROFILE_LIVED_EXPERIENCE"
export const PROFILE_SOCIAL_LINKS = "PROFILE_SOCIAL_LINKS"

export const PROFILE_ETHNICITY_AND_CULTURE_KEY = "ETHNICITY_AND_CULTURE"
export const PROFILE_ETHNICITY_AND_CULTURE_LIST_KEY = "LIST"
export const PROFILE_ETHNICITY_AND_CULTURE_OTHER_OPTION_KEY = "OTHER_OPTION"
export const PROFILE_FAITH_KEY = "FAITH"
export const PROFILE_FAITH_LIST_KEY = "LIST"
export const PROFILE_FAITH_OTHER_OPTION_KEY = "OTHER_OPTION"
export const PROFILE_GENDER_KEY = "GENDER"
export const PROFILE_GENDER_LIST_KEY = "LIST"
export const PROFILE_GENDER_OTHER_OPTION_KEY = "OTHER_OPTION"
export const PROFILE_ORIENTATION_KEY = "ORIENTATION"
export const PROFILE_ORIENTATION_LIST_KEY = "LIST"
export const PROFILE_ORIENTATION_OTHER_OPTION_KEY = "OTHER_OPTION"
export const PROFILE_LANGUAGE_KEY = "LANGUAGE"
export const PROFILE_LANGUAGE_LIST_KEY = "LIST"
export const PROFILE_LANGUAGE_OTHER_OPTION_KEY = "OTHER_OPTION"

export const PROFILE_PERSONALITIY_CASUAL_FORMAL = "CASUAL_FORMAL"
export const PROFILE_PERSONALITIY_PLAYFUL_ERNEST = "PLAYFUL_ERNEST"
export const PROFILE_PERSONALITIY_CALM_ENERGETIC = "CALM_ENERGETIC"
export const PROFILE_PERSONALITIY_STREET_SMART_BOOK_SMART = "STREET_SMART_BOOK_SMART"
export const PROFILE_PERSONALITIY_ACCOMODATING_CHALLENGING =
  "ACCOMODATING_CHALLENGING"
export const PROFILE_PERSONALITIY_DREAMER_OBJECTIVE = "DREAMER_OBJECTIVE"

export const PROFILE_MODALITIES_LIST_KEY = "LIST"
export const PROFILE_MODALITY_OTHER_KEY = "OTHER"

export const PROFILE_ROLES_PRIMARY_ROLE = "PRIMARY_ROLE"
export const PROFILE_ROLES_CREDENTIAL_ROLES_KEY = "CREDENTIAL_ROLES"

export const PROFILE_ROLES_COACHING_KEY = "COACHING"
export const PROFILE_ROLES_COACHING_ROLES_KEY = "ROLES"
export const PROFILE_ROLES_COACHING_OTHER_ROLE_KEY = "OTHER_ROLE"

export const PROFILE_ROLES_EDUCATOR_KEY = "EDUCATOR"
export const PROFILE_ROLES_EDUCATOR_ROLES_KEY = "ROLES"
export const PROFILE_ROLES_EDUCATOR_OTHER_ROLE_KEY = "OTHER_ROLE"

export const PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_KEY = "ALTERNATIVE_OR_HOLISTIC"
export const PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_ROLES_KEY = "ROLES"
export const PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_OTHER_ROLES_KEY = "OTHER_ROLES"

export const PROFILE_BASICS_FIRST_NAME = "FIRST_NAME"
export const PROFILE_BASICS_LAST_NAME = "LAST_NAME"
export const PROFILE_BASICS_TITLE = "TITLE"
export const PROFILE_BASICS_SHOW_TITLE = "SHOW_TITLE"
export const PROFILE_BASICS_CREDENTIAL_ABBREVIATIONS = "CREDENTIAL_ABBREVIATIONS"
export const PROFILE_BASICS_PRONOUNS = "PRONOUNS"

export const PROFILE_WORK_CONTACT_STATE = "STATE"
export const PROFILE_WORK_CONTACT_CITY = "CITY"
export const PROFILE_WORK_CONTACT_ZIPCODE = "ZIPCODE"

export const PROFILE_CREDENTIAL_TYPE = "PROFILE_CREDENTIAL_TYPE"

export const PROFILE_CREDENTIALS_ROLE = "ROLE"
export const PROFILE_CREDENTIALS_LICENSE_NUMBER = "LICENSE_NUMBER"
export const PROFILE_CREDENTIALS_LICENSE_STATE = "LICENSE_STATE"
export const PROFILE_CREDENTIALS_LICENSE_ISSUED_YEAR_MONTH =
  "LICENSE_ISSUED_YEAR_MONTH"

export const PROFILE_CREDENTIALS_SUPERVISIOR = "SUPERVISOR"
export const PROFILE_CREDENTIALS_TOTAL_HOURS_OF_SUPERVISED_WORK =
  "TOTAL_HOURS_OF_SUPERVISED_WORK"

export const PROFILE_CREDENTIALS_SUPERVISIOR_NAME = "SUPERVISOR_NAME"
export const PROFILE_CREDENTIALS_SUPERVISIOR_EMAIL = "SUPERVISOR_EMAIL"

export const PROFILE_CREDENTIALS_ACCREDITING_INSTITUE = "ACCREDITING_INSTITUE"
export const PROFILE_CREDENTIALS_DEGREE_OR_DIPLOMA_TYPE = "TYPE"
export const PROFILE_CREDENTIALS_DEGREE_OR_DIPLOMA_SUBJECT = "SUBJECT"
export const PROFILE_CREDENTIALS_ACADEMIC_CREDIT_HOURS = "ACADEMIC_CREDIT_HOURS"
export const PROFILE_CREDENTIALS_GRADUATION_YEAR = "GRADUATION_YEAR"

export const PROFILE_CREDENTIALS_CERTIFICATE_TITLE = "CERTIFICATE_TITLE"
export const PROFILE_CREDENTIALS_CERTIFICATE_ID = "CERTIFICATE_ID"
export const PROFILE_CREDENTIALS_TOTAL_HOURS_OF_TRAINING = "TOTAL_HOURS_OF_TRAINING"

export const PROFILE_CREDENTIALS_MEMBERSHIP_ORGANIZATION = "MEMBERSHIP_ORGANIZATION"
export const PROFILE_CREDENTIALS_MEMBERSHIP_ID = "MEMBERSHIP_ID"
export const PROFILE_CREDENTIALS_YEAR_JOINED = "YEAR_JOINED"

export const PROFILE_CREDENTIALS_EXAM_TITLE = "EXAM_TITLE"
export const PROFILE_CREDENTIALS_YEAR_PASSED = "YEAR_PASSED"

export const PROFILE_MODALITIES_LIST = [
  "Acceptance and Commitment (ACT)",
  "Adlerian",
  "AEDP",
  "Applied Behavioral Analysis",
  "Art Therapy",
  "Attachment-based",
  "Biofeedback",
  "Brainspotting",
  "Christian Counseling",
  "Clinical Supervision and Licensed Supervisors",
  "Coaching",
  "Cognitive Behavioral (CBT)",
  "Cognitive Processing (CPT)",
  "Compassion Focused",
  "Dance/Movement Therapy",
  "Dialectical Behavior Therapy (DBT)",
  "Eclectic",
  "EMDR",
  "Emotionally Focused",
  "Energy Psychology",
  "Existential",
  "Experiential Therapy",
  "Exposure Response Prevention",
  "Expressive Arts",
  "Family / Marital",
  "Family Systems",
  "Feminist",
  "Forensic Psychology",
  "Gestalt",
  "Gottman Method",
  "Hakomi",
  "Humanistic",
  "Hypnotherapy",
  "Imago",
  "Integrative",
  "Internal Family Systems (IFS)",
  "Interpersonal",
  "Jungian",
  "Law of Attraction",
  "Mindfulness-Based (MBCT)",
  "Motivational Interviewing",
  "Multicultural",
  "Music Therapy",
  "Narrative",
  "Neuro-Linguistic Programming (NLP)",
  "Neurofeedback",
  "Parent-Child Interaction (PCIT)",
  "Person-Centered",
  "Play Therapy",
  "Positive Psychology",
  "Prolonged Exposure Therapy",
  "Psychoanalytic",
  "Psychobiological Approach to Couple Therapy (PACT)",
  "Psychodynamic",
  "Psychological Testing and Evaluation",
  "Rational Emotive Behavior (REBT)",
  "Reality Therapy",
  "Relational",
  "Sandplay",
  "Schema Therapy",
  "Solution Focused Brief (SFBT)",
  "Somatic",
  "Strength-Based",
  "Structural Family Therapy",
  "Transpersonal",
  "Trauma Focused",
  "Other",
]

// export const S3_ADMIN_DOCUMENT_BASE_URL =
//   "https://68ai58w928.execute-api.us-west-2.amazonaws.com"
export const S3_ADMIN_DOCUMENT_ROUTE = "/adminGetUserDocument"
export const S3_ADMIN_DOCUMENT_KEY =
  "user_document/service_agreement/227ae278-4301-4361-aeb8-7c8a01f0c5ab/1673469260139"
// export const S3_PHOTO_BASE_URL =
//   "https://z1mats4fo6.execute-api.us-west-2.amazonaws.com"
export const S3_PHOTO_ROUTE = "/v1"
// export const S3_DOCUMENT_BASE_URL =
//   "https://we230do01e.execute-api.us-west-2.amazonaws.com"
export const S3_DOCUMENT_ROUTE = "/upload_document"
export const UPLOAD_DOCUMENT_TYPE_PRIMARY_CREDENDTIAL = "primary_credential"
export const UPLOAD_DOCUMENT_TYPE_PROOF_OF_INSURANCE = "proof_of_insurance"
export const UPLOAD_DOCUMENT_TYPE_FRONT_ID = "id_front"
export const UPLOAD_DOCUMENT_TYPE_BACK_ID = "id_back"

type S3Config = {
  S3_ADMIN_DOCUMENT_BASE_URL: string
  S3_PHOTO_BASE_URL: string
  S3_DOCUMENT_BASE_URL: string
}

const S3_CONFIG: Record<RuntimeEnv, S3Config> = {
  production: {
    S3_ADMIN_DOCUMENT_BASE_URL:
      "https://bk2plo4te2.execute-api.us-west-2.amazonaws.com",
    S3_PHOTO_BASE_URL: "https://sztsl3ce03.execute-api.us-west-2.amazonaws.com",
    S3_DOCUMENT_BASE_URL: "https://8nsppxpyxc.execute-api.us-west-2.amazonaws.com",
    // ... other production constants
  },
  development: {
    S3_ADMIN_DOCUMENT_BASE_URL:
      "https://68ai58w928.execute-api.us-west-2.amazonaws.com",
    S3_PHOTO_BASE_URL: "https://0r4o1mpxn5.execute-api.us-west-2.amazonaws.com",
    S3_DOCUMENT_BASE_URL: "https://votlyw0p4e.execute-api.us-west-2.amazonaws.com",
  },
}

export const {
  S3_ADMIN_DOCUMENT_BASE_URL,
  S3_PHOTO_BASE_URL,
  S3_DOCUMENT_BASE_URL,
  // ... export other constants
} = S3_CONFIG[env]

export const ETHNICITY_AND_CULTURE_LIST = [
  "African",
  "Afro-Caribbean",
  "Arab",
  "Asian",
  "Biracial",
  "Black",
  "East Asian",
  "European",
  "Hispanic",
  "Indigenous",
  "Latina",
  "Latino",
  "Latinx",
  "Mixed Race",
  "Multi-ethnic",
  "Pacific Islander",
  "Person of Color",
  "Polynesian",
  "South Asian",
  "Southeast Asian",
  "White",
]
export const FAITH_LIST = [
  "African Traditional Religion",
  "Atheist",
  "Agnostic",
  "Bahá'í",
  "Buddhist",
  "Christian",
  "Hindu",
  "Indigenous religion",
  "Indigenous spirituality",
  "Jain",
  "Jewish faith",
  "Muslim",
  "Pagan / Earth-centered Faith",
  "Rastafarian",
  "Santeria / Pali / Ifa",
  "Shinto",
  "Sikh",
  "Spiritual",
  "Taoist",
  "Wicca(n)",
  "Zoroastrianism",
]
export const GENDER_LIST = [
  "Androgynous",
  "Agender",
  "Bigender",
  "Cisgender",
  "Demigender",
  "Femme",
  "Gender Non-conforming",
  "Genderfluid",
  "Genderqueer",
  "Gender questioning",
  "Intersex",
  "Masc / Butch / Stud",
  "Neutrois",
  "Non-binary",
  "Of Trans Experience",
  "Third gender",
  "Transfeminine",
  "Transgender",
  "Transmasculine",
  "Two-Spirit",
  "Woman",
]

export const ORIENTATION_LIST = [
  "Androsexual",
  "Asexual",
  "BDSM-oriented",
  "Bisexual",
  "Demisexual",
  "Gay",
  "Gynesexual",
  "Heterosexual",
  "Lesbian",
  "Pansexual",
  "Queer",
  "Skoliosexual",
]
export const LANGUAGE_LIST = [
  "Amharic",
  "Arabic",
  "Bengali",
  "Cherokee",
  "Chinese - Cantonese",
  "Chinese - Mandarin",
  "Chinese - Wu (Shanghainese)",
  "Chinese - Yue",
  "Dutch",
  "English",
  "Estonian",
  "Farsi (Persian)",
  "Finnish",
  "French",
  "German",
  "Gujarati",
  "Greek",
  "Hausa",
  "Hebrew",
  "Hindi",
  "Hungarian",
  "Igbo",
  "Indonesian/Malay",
  "Irish (Gaeilge)",
  "Italian",
  "Japanese",
  "Javanese",
  "Kannada",
  "Kazakh",
  "Khmer (Cambodian)",
  "Korean",
  "Lahnda (Western Punjabi)",
  "Malay",
  "Maori",
  "Marathi",
  "Mohawk",
  "Navajo",
  "Ojibwe",
  "Persian",
  "Polish",
  "Portuguese",
  "Punjabi",
  "Quechua",
  "Russian",
  "Samoan",
  "Scottish Gaelic",
  "Spanish",
  "Swahili",
  "Tagalog (Filipino)",
  "Tamil",
  "Telugu",
  "Thai",
  "Tibetan",
  "Tongan",
  "Turkish",
  "Urdu",
  "Uzbek",
  "Vietnamese",
  "Welsh",
  "Xhosa",
  "Yoruba",
  "Zulu",
]
export const LOGIN_PANEL = "LOGIN_PANEL"
export const CREATE_ACCOUNT_PANEL = "CREATE_ACCOUNT_PANEL"
export const VERIFY_EMAIL_PANEL = "VERIFY_EMAIL_PANEL"
export const CREDIT_CARD_PANEL = "CREDIT_CARD_PANEL"
export const CHECKOUT_PANEL = "CHECKOUT_PANEL"
export const CHECKOUT_ACCORDIONS_SIGN_UP = "CHECKOUT_ACCORDIONS_SIGN_UP"
export const CHECKOUT_ACCORDIONS_CREATE_ACCOUNT =
  "CHECKOUT_ACCORDIONS_CREATE_ACCOUNT"
export const CHECKOUT_ACCORDIONS_LOGGED_IN_NO_CREDIT_CARD =
  "CHECKOUT_ACCORDIONS_LOGGED_IN_NO_CREDIT_CARD"
export const CHECKOUT_ACCORDIONS_LOGGED_IN_WITH_CREDIT_CARD =
  "CHECKOUT_ACCORDIONS_LOGGED_IN_WITH_CREDIT_CARD"

export const TERMS_OF_USE_URL = "/policies/terms-of-use"
export const PRIVACY_POLICY_URL = "/policies/privacy-policy"
export const ZESTLIFE_URLS = {
  POLICIES: {
    TERMS_OF_USE_URL,
    PRIVACY_POLICY_URL,
  },
}

export const COHORT_USER_CONTACT_NOTE = "NOTE"
export const COHORT_USER_PREFERRED_CONTACT_TYPE = "PREFERRED_CONTACT_TYPE"
export const COHORT_USER_PREFERRED_CONTACT_EMAIL = "EMAIL"
export const COHORT_USER_PREFERRED_CONTACT_PHONE = "PHONE"
export const COHORT_USER_STATUS_PENDING: CohortUserStatus = {
  value: "PENDING",
  text: "Pending",
}
export const COHORT_USER_STATUS_ACCEPTED: CohortUserStatus = {
  value: "ACCEPTED",
  text: "Accepted",
}
export const COHORT_USER_STATUS_DECLINED: CohortUserStatus = {
  value: "DECLINED",
  text: "Declined",
}
export const COHORT_USER_STATUSES: CohortUserStatus[] = [
  COHORT_USER_STATUS_PENDING,
  COHORT_USER_STATUS_ACCEPTED,
  COHORT_USER_STATUS_DECLINED,
]

export const PAGINATED_TABLE_ROW_CLICK = "PAGINATED_TABLE_ROW_CLICK"
export const PAGINATED_TABLE_INDIVIDUAL_CELL_CLICK =
  "PAGINATED_TABLE_INDIVIDUAL_CELL_CLICK"

export const CREATE_GROUP_SCREEN_INTRO = "INTRO"
export const CREATE_GROUP_SCREEN_OVERVIEW = "OVERVIEW"
export const CREATE_GROUP_SCREEN_SNAPSHOT = "SNAPSHOT"
export const CREATE_GROUP_SCREEN_TITLE = "TITLE"
export const CREATE_GROUP_SCREEN_PITCH = "PITCH"
export const CREATE_GROUP_SCREEN_TAGS = "TAGS"
export const CREATE_GROUP_SCREEN_GROUP_PICTURE = "GROUP_PICTURE"
export const CREATE_GROUP_SCREEN_DEEP_DIVE = "DEEP_DIVE"
export const CREATE_GROUP_SCREEN_TYPE = "TYPE"
export const CREATE_GROUP_SCREEN_PRE_REQUISITE = "PRE_REQUISITE"
export const CREATE_GROUP_SCREEN_PEOPLE = "PEOPLE"
export const CREATE_GROUP_SCREEN_EXPECTATION = "EXPECTATION"
export const CREATE_GROUP_SCREEN_LEADERSHIP = "LEADERSHIP"
export const CREATE_GROUP_SCREEN_FACILITATOR = "FACILITATOR"
export const CREATE_GROUP_SCREEN_MESSAGE_RECIPIENTS = "MESSAGE_RECIPIENTS"
export const CREATE_GROUP_SCREEN_COHOSTS = "COHOSTS"
export const CREATE_GROUP_SCREEN_LICENSURE = "LICENSURE"
export const CREATE_GROUP_SCREEN_YOU = "YOU"
export const CREATE_GROUP_SCREEN_SIZE = "SIZE"
export const CREATE_GROUP_SCREEN_LOCATION = "LOCATION"
export const CREATE_GROUP_SCREEN_PAYMENT = "PAYMENT"
export const CREATE_GROUP_SCREEN_CONSULTATION = "CONSULTATION"
export const CREATE_GROUP_SCREEN_STRUCTURE = "STRUCTURE"
export const CREATE_GROUP_SCREEN_FEATURE_GROUP_IN_NEWSLETTER =
  "FEATURE_GROUP_IN_NEWSLETTER"
export const CREATE_GROUP_SCREEN_LOGISTICS = "LOGISTICS"
export const CREATE_GROUP_SCREEN_COHORT = "COHORT"
export const CREATE_GROUP_SCREEN_GROUP_PREVIEW = "GROUP_PREVIEW"
export const CREATE_GROUP_SCREEN_PUBLISH = "PUBLISH"
export const CREATE_GROUP_SCREEN_RECRUITING_PHASE = "RECRUITING_PHASE"

export const COHORT_ACTION_CREATE = "CREATE"
export const COHORT_ACTION_UPDATE = "UPDATE"

export const COHORT_PRICE_TYPE_PER_SESSION = "PER_SESSION"
export const COHORT_PRICE_TYPE_ALL_UPFRONT = "ALL_UPFRONT"

export const OG_SITE_NAME = "ZestLife"
export const OG_TYPE_PROFILE = "profile"
export const OG_TYPE_ARTICLE = "article"
export const OG_LOCALE_US = "en_US"
export const OG_IMAGE_TYPE_PNG = "image/png"
export const OG_TYPE_WEBSITE = "website"

export const CREATE_PROFILE_SCRAPE_PROFESSIONAL_PROFILE_SCREEN = "IMPORT_PROFILE"
export const CREATE_PROFILE_NAME_CARD_SCREEN = "NAME_CARD"
export const CREATE_PROFILE_ORG_LEADER_CHOICE_SCREEN =
  "ORG_LEADER_PUBLIC_PROFILE_CHOICE"
export const CREATE_PROFILE_WORK_CONTACT_SCREEN = "WORK_CONTACT"
export const CREATE_PROFILE_CREDENTIALS_SCREEN = "CREDENTIALS"
export const CREATE_PROFILE_ROLES_SCREEN = "ROLES"
export const CREATE_PROFILE_MODALITIES_SCREEN = "FRAMEWORKS"
export const CREATE_PROFILE_PERSONALITIES_SCREEN = "PERSONALITY"
export const CREATE_PROFILE_PROFILE_PHOTO_SCREEN = "PROFILE_PHOTO"
export const CREATE_PROFILE_YOUR_STORY_SCREEN = "YOUR_STORY"
export const CREATE_PROFILE_PUBLISH_SCREEN = "REQUEST_PUBLICATION"
export const CREATE_PROFILE_LIVED_EXPERIENCE_SCREEN = "LIVED_EXPERIENCE"
export const CREATE_PROFILE_SOCIAL_LINKS_SCREEN = "SOCIAL_LINKS"
export const CREATE_PROFILE_PROFILE_EDIT_SCREEN = "PROFILE_EDIT"

export const DAYS_OF_THE_WEEK: DayOfWeekOption[] = [
  { text: "Su", value: "Sunday" },
  { text: "M", value: "Monday" },
  { text: "T", value: "Tuesday" },
  { text: "W", value: "Wednesday" },
  { text: "T", value: "Thursday" },
  { text: "F", value: "Friday" },
  { text: "Sa", value: "Saturday" },
]

export const EASTERN_TIME: TimeZone = {
  value: "America/New_York",
  text: "ET - America/New York",
  shortText: "ET",
}
export const CENTRAL_TIME: TimeZone = {
  value: "America/Chicago",
  text: "CT - America/Chicago",
  shortText: "CT",
}
export const MOUNTAIN_TIME: TimeZone = {
  value: "America/Denver",
  text: "MT - America/Denver",
  shortText: "MT",
}
export const PACIFIC_TIME: TimeZone = {
  value: "America/Los_Angeles",
  text: "PT - America/Los Angeles",
  shortText: "PT",
}
export const ALASKAN_TIME: TimeZone = {
  value: "America/Anchorage",
  text: "AKT - America/Anchorage",
  shortText: "AKT",
}
export const HAWAIIAN_TIME: TimeZone = {
  value: "Pacific/Honolulu",
  text: "HT - Pacific/Honolulu",
  shortText: "HT",
}
export const TIME_ZONES: TimeZone[] = [
  EASTERN_TIME,
  CENTRAL_TIME,
  MOUNTAIN_TIME,
  PACIFIC_TIME,
  ALASKAN_TIME,
  HAWAIIAN_TIME,
]

export const CREATE_GROUP_INFO_SCREEN = "CREATE_GROUP_INFO_SCREEN"

export const UI_STYLE_PRIMARY_BLUE_BLACK = "#092C3C"
export const UI_STYLE_PRIMARY_COLOR = "#00B2FF"
export const UI_STYLE_SECONDARY_COLOR = "#E6FF63"
export const UI_STYLE_TERTIARY_COLOR = "#FFE0AD"
export const UI_STYLE_YELLOW_COLOR_BUTTON = UI_STYLE_SECONDARY_COLOR
export const UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED = "#c2d753"
export const UI_STYLE_BLACK_COLOR_BUTTON = UI_STYLE_PRIMARY_BLUE_BLACK
export const UI_STYLE_BLACK_COLOR_BUTTON_PUSHED = "#32596a"
export const UI_STYLE_HEADER_FONT = "var(--font-bebas)"
export const UI_STYLE_PRIMARY_FONT = "var(--font-roboto)"
export const UI_STYLE_ERROR_COLOR = "rgba(255, 81, 81, 0.5)"
export const UI_STYLE_WARNING_COLOR = "rgba(230, 255, 99, 0.8)"
export const UI_STYLE_SUCCESS_COLOR = "rgba(116, 255, 138, 0.5)"
export const UI_STYLE_INFO_COLOR = "rgba(0, 178, 255, 0.5)"

export const ONBOARDING_STEP_GROUP_LEADER_CREATE_GROUP = "CREATE_GROUP"
export const ONBOARDING_STEP_GROUP_LEADER_CREATE_COHORT = "CREATE_COHORT"
export const ONBOARDING_STEP_GROUP_LEADER_CREATE_PROFILE = "CREATE_PROFILE"
export const ONBOARDING_STEP_GROUP_LEADER_SETUP_PAYMENT = "SETUP_PAYMENT"
export const ONBOARDING_STEP_GROUP_LEADER_PROOF_OF_INSURANCE = "PROOF_OF_INSURANCE"
export const ONBOARDING_STEP_GROUP_LEADER_SIGN_DOCUMENTS = "SIGN_DOCUMENTS"
export const ONBOARDING_STEP_GROUP_LEADER_BACKGROUND_CHECK_CONSENT =
  "BACKGROUND_CHECK_CONSENT"

export const ONBOARDING_DOCUMENT_UPLOAD_LIABILITY_ICON = "LIABILITY_ICON"
export const ONBOARDING_DOCUMENT_UPLOAD_CREDENTIAL_ICON = "CREDENTIAL_ICON"
export const ONBOARDING_DOCUMENT_UPLOAD_FRONT_ID_ICON = "FRONT_ID_ICON"
export const ONBOARDING_DOCUMENT_UPLOAD_BACK_ID_ICON = "BACK_ID_ICON"

export const WHATS_NEXT_PICTURE_GROUP_LOVE = "GROUP_LOVE"
export const WHATS_NEXT_ICON_PAPER_PLANE = "PAPER_PLANE"
export const WHATS_NEXT_ICON_CONSULTING = "CONSULTING"
export const WHATS_NEXT_ICON_BUSINESS_DIAGRAM = "BUSINESS_DIAGRAM"
export const WHATS_NEXT_ICON_READING = "READING"

export const LEADER_ACTIVE_STATE = "LEADER_ACTIVE_STATE"
export const MEMBER_ACTIVE_STATE = "MEMBER_ACTIVE_STATE"
export const MEMBER_ONLY_ACTIVE_STATE = "MEMBER_ONLY_ACTIVE_STATE"
export const ADMIN_ACTIVE_STATE = "ADMIN_ACTIVE_STATE"
export const VISITOR_ACTIVE_STATE = "VISITOR_ACTIVE_STATE" // logged out state

export const GROUP_DETAIL_PAGE = "GROUP_DETAIL_PAGE"
export const CREATE_GROUP_COHORTS_PAGE = "CREATE_GROUP_COHORTS_PAGE"
export const COHORT_BEST_PRACTICES = "cohort_best_practices"
export const GROUP_BEST_PRACTICES = "group_best_practices"
export const CHECKOUT_BEST_PRACTICES = "checkout_best_practices"

export const LEADER_DASHBOARD_TODO_TAB = "To-do's"
export const LEADER_DASHBOARD_GROUPS_TAB = "My Groups"
export const LEADER_DASHBOARD_SCHEDULE_TAB = "Schedule"
export const LEADER_DASHBOARD_TODO_TAB_SEAT_REQUESTS_SUB_TAB = "Seat Requests"
export const LEADER_DASHBOARD_TODO_TAB_ATTENDANCE_SUB_TAB = "Attendance"
export const LEADER_DASHBOARD_GROUPS_TAB_PUBLISHED_SUB_TAB = "Active Groups"
export const LEADER_DASHBOARD_GROUPS_TAB_UNPUBLISHED_SUB_TAB = "Inactive Groups"
export const LEADER_DASHBOARD_SCHEDULE_TAB_NEXT_MEETING_SUB_TAB = "Next Meetings"
export const LEADER_DASHBOARD_SCHEDULE_TAB_PAST_MEETINGS_SUB_TAB = "Past Meetings"

export const EMPTY_STATE_ACTIVE_GROUPS = "EMPTY_STATE_ACTIVE_GROUPS"
export const EMPTY_STATE_INACTIVE_GROUPS = "EMPTY_STATE_INACTIVE_GROUPS"
export const EMPTY_STATE_UPCOMING_SCHEDULE = "EMPTY_STATE_UPCOMING_SCHEDULE"
export const EMPTY_STATE_PAST_SCHEDULE = "EMPTY_STATE_PAST_SCHEDULE"
export const EMPTY_STATE_ATTENDANCE = "EMPTY_STATE_ATTENDANCE"
export const EMPTY_STATE_SEAT_REQUESTS = "EMPTY_STATE_SEAT_REQUESTS"
export const EMPTY_STATE_CONFIRMED_MEMBERS = "EMPTY_STATE_CONFIRMED_MEMBERS"
export const EMPTY_STATE_REQUESTED_MEMBERS = "EMPTY_STATE_REQUESTED_MEMBERS"
export const EMPTY_STATE_DENIED_MEMBERS = "EMPTY_STATE_DENIED_MEMBERS"
export const EMPTY_STATE_COHORTS = "EMPTY_STATE_COHORTS"
export const EMPTY_STATE_CURRENT_COHORTS = "EMPTY_STATE_CURRENT_COHORTS"

export const LEADER_GROUP_DETAIL_OVERVIEW_TAB = "Overview"
export const LEADER_GROUP_DETAIL_COHORTS_TAB = "Cohorts"

export const STATUS_CONTAINER_GRAY = "GRAY"
export const STATUS_CONTAINER_WHITE = "WHITE"
export const STATUS_CONTAINER_TRANSPARENT = "TRANSPARENT"

export const LEADER_COHORT_DETAIL_TODOS_TAB = "To-do's"
export const LEADER_COHORT_DETAIL_MEETINGS_TAB = "Meetings"
export const LEADER_COHORT_DETAIL_MEMBERS_TAB = "Members"
export const LEADER_COHORT_DETAIL_OVERVIEW_TAB = "Overview"
export const LEADER_COHORT_DETAIL_ANNOUNCEMENTS_TAB = "Announcements"
export const LEADER_COHORT_DETAIL_VIEW_MEMBER_DIALOG = "VIEW_MEMBER_DIALOG"
export const LEADER_COHORT_DETAIL_MEMBER_CONSULTATION_DIALOG =
  "MEMBER_CONSULTATION_DIALOG"
export const LEADER_COHORT_DETAIL_LEADER_ANNOUNCEMENT_DIALOG =
  "LEADER_ANNOUNCEMENT_DIALOG"
export const LEADER_COHORT_DETAIL_MEMBERS_TAB_SUB_TAB_CONFIRMED_MEMBERS_TAB =
  "Confirmed"
export const LEADER_COHORT_DETAIL_MEMBERS_TAB_SUB_TAB_REQUESTED_MEMBERS_TAB =
  "Requested"
export const LEADER_COHORT_DETAIL_MEMBERS_TAB_SUB_TAB_DENIED_MEMBERS_TAB = "Denied"
export const LEADER_COHORT_DETAIL_TODOS_TAB_SUB_TAB_SEAT_REQUESTS_TAB =
  "Seat Requests"
export const LEADER_COHORT_DETAIL_TODOS_TAB_SUB_TAB_ATTENDANCE_TAB = "Attendance"
export const LEADER_COHORT_DETAIL_MEETINGS_TAB_SUB_TAB_NEXT_MEETING = "Next Meetings"
export const LEADER_COHORT_DETAIL_MEETINGS_TAB_SUB_TAB_PAST_MEETING = "Past Meetings"
export const LEADER_COHORT_DETAIL_OVERVIEW_TAB_SUB_TAB_OVERVIEW = "Overview"
export const LEADER_COHORT_DETAIL_OVERVIEW_TAB_SUB_TAB_BUSINESS = "Business"

export const PAYMENT_STATUS_UPFRONT_PENDING = "UPFRONT_PENDING"
export const PAYMENT_STATUS_UPFRONT_PAID = "UPFRONT_PAID"
export const PAYMENT_STATUS_UPFRONT_REFUNDED = "UPFRONT_REFUNDED"

export const WARNING_ICON_TYPE = "WARNING_ICON_TYPE"
export const ERROR_ICON_TYPE = "ERROR_ICON_TYPE"

export const GROUP_STATUS_IN_REVIEW = "REVIEW"
export const GROUP_STATUS_PUBLISHED = "PUBLISHED"
export const GROUP_STATUS_DRAFT = "DRAFT"
export const GROUP_STATUS_INACTIVE = "INACTIVE"
export const GROUP_STATUSES = [
  { value: GROUP_STATUS_DRAFT, text: "Draft" },
  { value: GROUP_STATUS_IN_REVIEW, text: "Review" },
  { value: GROUP_STATUS_PUBLISHED, text: "Published" },
  { value: GROUP_STATUS_INACTIVE, text: "Inactive" },
]

export const COHORT_STATUS_PENDING = "PENDING"
export const COHORT_STATUS_RUNNING = "RUNNING"
export const COHORT_STATUS_COMPLETE = "COMPLETE"
export const COHORT_STATUS_CANCELED = "CANCELED"

export const SESSION_STATUS_PENDING = "PENDING"
export const SESSION_STATUS_CANCELED = "CANCELED"
export const SESSION_STATUS_ONGOING = "ONGOING"
export const SESSION_STATUS_COMPLETE = "COMPLETE"

export const SESSION_ATTENDANCE_STATUS_ATTENDED = "ATTENDED"
export const SESSION_ATTENDANCE_STATUS_MISSED_CHARGE = "MISSED_CHARGE"
export const SESSION_ATTENDANCE_STATUS_MISSED_NO_CHARGE = "MISSED_NO_CHARGE"

export const SESSION_ATTENDANCE_STATUS_PENDING = "PENDING"
export const SESSION_ATTENDANCE_STATUS_COMPLETE = "COMPLETE"

export const PROVIDER_VERIFICATION_PROOF_OF_INSURANCE = "PROOF_OF_INSURANCE"
export const PROVIDER_VERIFICATION_CREDENTIAL = "CREDENTIAL"
export const PROVIDER_VERIFICATION_BAA = "BAA"
export const PROVIDER_VERIFICATION_SERVICE_AGREEMENT = "SERVICE_AGREEMENT"
export const BACKGROUND_CHECK = "BACKGROUND_CHECK"

export const NAV_TYPE_SIMPLE = "SIMPLE"
export const NAV_TYPE_SOLID = "SOLID"

export const LEADER_GROUP_PAGE_BREAD_CRUMB_PAGE_TYPE = "LEADER_GROUP_PAGE"
export const LEADER_COHORT_PAGE_BREAD_CRUMB_PAGE_TYPE = "LEADER_COHORT_PAGE"
export const LEADER_SESSION_PAGE_BREAD_CRUMB_PAGE_TYPE = "LEADER_SESSION_PAGE"

export const LEADER_SESSION_DETAIL_PAGE_SESSION_PLAN_DIALOG = "SESSION_PLAN_DIALOG"
export const LEADER_SESSION_DETAIL_PAGE_SESSION_REFLECTION_DIALOG =
  "SESSION_REFLECTION_DIALOG"
export const LEADER_SESSION_DETAIL_PAGE_ANNOUNCEMENT_DIALOG =
  "LEADER_ANNOUNCEMENT_DIALOG"
export const LEADER_SESSION_DETAIL_PAGE_ATTENDANCE_DIALOG = "ATTENDANCE_DIALOG"

export const MEMBER_COHORT_PAGE_BREAD_CRUMB_PAGE_TYPE = "MEMBER_COHORT_PAGE"
export const MEMBER_SESSION_PAGE_BREAD_CRUMB_PAGE_TYPE = "MEMBER_SESSION_PAGE"

export const MEMBER_COHORT_PAGE_NEXT_SESSIONS_TAB = "Next Meetings"
export const MEMBER_COHORT_PAGE_PAST_SESSIONS_TAB = "Past Meetings"
export const TITLE_LIST = ["Dr.", "Prof.", "Rev.", "Rabbi"]
export const PRONOUNS_LIST = [
  "She/her/hers",
  "He/him/His",
  "They/them",
  "Xe/Xem/Xyrs",
  "Ze/hir/hirs",
  "Ze/zir/zirs",
  "Use my name for pronouns",
]
export const COACHING_MODAL = "coaching modal"
export const EDUCATOR_MODAL = "educator modal"
export const ALTERNATIVE_OR_HOLISTIC_MODAL = "alternative holistic modal"
export const ETHNICITY_AND_CULTURE = "ETHNICITY_AND_CULTURE"
export const FAITH = "FAITH"
export const GENDER = "GENDER"
export const ORIENTATION = "ORIENTATION"
export const LANGUAGE = "LANGUAGE"

export const SEARCH_FILTER_IN_PERSON: SearchFilter = {
  text: "In-person",
  type: "IN_PERSON",
}
export const SEARCH_FILTER_VIRTUAL: SearchFilter = {
  text: "Virtual",
  type: "VIRTUAL",
}
export const SEARCH_FILTER_WORKSHOP: SearchFilter = {
  text: "Workshops",
  type: "WORKSHOP",
  urlParam: "workshops",
}
export const SEARCH_FILTER_THERAPY_GROUP: SearchFilter = {
  text: "Therapy group",
  type: "THERAPY_GROUP",
  urlParam: "therapy-groups",
}
export const SEARCH_FILTER_SUPPORT_GROUP: SearchFilter = {
  text: "Support group",
  type: "SUPPORT_GROUP",
  urlParam: "support-groups",
}
export const SEARCH_FILTER_RETREATS: SearchFilter = {
  text: "Retreats",
  type: "RETREAT",
  urlParam: "retreats",
}
export const SEARCH_FILTER_PROVIDER_GROUP: SearchFilter = {
  text: "Clinicial peer group",
  type: "PROVIDER_GROUP",
  urlParam: "provider-groups",
}
export const SEARCH_FILTER_THERAPISTS: SearchFilter = {
  text: "Therapists",
  type: "THERAPISTS",
  urlParam: "therapists",
}
export const SEARCH_FILTER_COACHES: SearchFilter = {
  text: "Coaches",
  type: "COACHES",
  urlParam: "coaches",
}
export const SEARCH_FILTER_ALTERNATIVE: SearchFilter = {
  text: "Alternative",
  type: "ALTERNATIVE",
  urlParam: "alternative",
}
export const SEARCH_FILTERS: SearchFilter[] = [
  SEARCH_FILTER_IN_PERSON,
  SEARCH_FILTER_VIRTUAL,
  SEARCH_FILTER_THERAPY_GROUP,
  SEARCH_FILTER_WORKSHOP,
  SEARCH_FILTER_SUPPORT_GROUP,
  SEARCH_FILTER_RETREATS,
  SEARCH_FILTER_PROVIDER_GROUP,
  // SEARCH_FILTER_THERAPISTS,
  // SEARCH_FILTER_COACHES,
  // SEARCH_FILTER_ALTERNATIVE,
]
// Filter rows per search tab (home page Groups | Providers | Organizations
// toggle). The provider-type chips were hidden from the groups row above
// because search_groups_public_v2 ignores provider_types; the Providers tab
// filters on them for real.
export const SEARCH_FILTERS_PROVIDERS: SearchFilter[] = [
  SEARCH_FILTER_THERAPISTS,
  SEARCH_FILTER_COACHES,
  SEARCH_FILTER_ALTERNATIVE,
]
export const SEARCH_FILTERS_ORGANIZATIONS: SearchFilter[] = []
export const SEARCH_FILTERS_BY_TYPE: Record<string, SearchFilter[]> = {
  groups: SEARCH_FILTERS,
  providers: SEARCH_FILTERS_PROVIDERS,
  organizations: SEARCH_FILTERS_ORGANIZATIONS,
}
export const COHORT_FLAG_DO_NOT_CHARGE = "DO_NOT_CHARGE"

export const TEST_ANNOUNCEMENT = {
  date: "2024-12-01T04:37:23.948545",
  content: `<p class=" ql-align-center  text-center"><span class=" ql-size-huge  text-[32px] tracking-[.03em]">Welcome to the best group ever!</span></p><p><span class=" ql-size-small  text-[10px]">Whether you have a small appetite for change</span></p><p>Normal</p><p><span class=" ql-size-large  text-[18px] tracking-[.03em]">Large</span></p><p><span class=" ql-size-huge  text-[32px] tracking-[.03em]">Huge</span></p><p>we expect you to be <strong>bold</strong>, and to <em>LEAN in</em>, and to <u>understand</u> that change only happens when you <s>strike</s> out old habits and <a href="google.com" rel="noopener noreferrer" target="_blank">link them to real change</a>. expect the winds of change to be <span style="color: rgb(230, 0, 0);">red</span></p><p class=" ql-align-right  text-right">Maybe justify your change to the right</p><p>order them</p><ol><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>first</li><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>second</li></ol><p><br></p><p>Bullets</p><ol class="list-disc list-inside"><li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>first</li><li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>second</li></ol><p><br></p><p>or no indent</p><p class=" ql-indent-1  pl-4">one indent</p><p class=" ql-indent-2  pl-8">two indent</p><p class=" ql-indent-2  pl-8"><br></p><p>cant wait to see you</p><p><br></p>`,
}
export const TEST_ANNOUNCEMENT_1 = {
  date: "2024-12-01T04:37:23.948545",
  content: `<p><span class=" ql-size-small  text-[10px]">small</span></p><p>norm</p><p><span class=" ql-size-large  text-[28px] tracking-[.03em]">large</span></p><p><span class=" ql-size-huge  text-[32px] tracking-[.03em]">huge</span></p><p><strong>bold</strong></p><p><em>itlaic</em></p><p><u>under</u></p><p><s>strike</s></p><p><a href="google.com" rel="noopener noreferrer" target="_blank">link</a></p><p><span style="color: rgb(230, 0, 0);">red</span></p><p class=" ql-align-center  text-center">middle</p><p class=" ql-align-right  text-right">right</p><p class=" ql-indent-1  pl-4">indent</p><p class=" ql-indent-2  pl-8">indent 2</p><p class=" ql-indent-3  pl-12">indent 3</p><p class=" ql-indent-4  pl-16">indent 4</p><p><br></p><ol><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>first</li><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>second</li></ol><p><br></p><ol class="list-disc list-inside"><li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>bullet</li></ol><p><br></p><p>justify me all the way justify me all the wayjustify me all the wayjustify me all the way justify me all the way justify me all the wayjustify me all the wayjustify me all the way justify me all the way justify me all the wayjustify me all the wayjustify me all the way</p>`,
}

export const MESSAGE_TYPE_DIRECT = "direct"
export const MESSAGE_TYPE_COHORT_ANNOUNCEMENT = "cohort_announcement"
export const MESSAGE_TYPE_SESSION_ANNOUNCEMENT = "session_announcement"

export const USER_SURVEY_TYPE_POST_SIGNUP = "POST_SIGNUP"
export const USER_SURVEY_TYPE_POST_PROVIDER_ONBOARDING = "POST_PROVIDER_ONBOARDING"

export const ADD_USER_OPT_IN_TRANSACT_OFF_PLATFORM = "TRANSACT_OFF_PLATFORM"
export const ADD_USER_OPT_IN_TRANSACT_ON_PLATFORM = "TRANSACT_ON_PLATFORM"

export const TEXT_REFINEMENT_AUDIENCE_GENERAL = "general"
export const TEXT_REFINEMENT_AUDIENCE_NEW_CLIENTS = "new_clients"
export const TEXT_REFINEMENT_AUDIENCE_EXISTING_MEMBERS = "existing_members"
export const TEXT_REFINEMENT_AUDIENCE_PROFESSIONALS = "professionals"

export const TEXT_REFINEMENT_EMPHASIS_GENERAL = "general"
export const TEXT_REFINEMENT_EMPHASIS_BENEFITS = "benefits"
export const TEXT_REFINEMENT_EMPHASIS_COMMUNITY = "community"
export const TEXT_REFINEMENT_EMPHASIS_SUPPORT = "support"
export const TEXT_REFINEMENT_EMPHASIS_EXPERTISE = "expertise"

export const TEXT_REFINEMENT_TONE_BALANCED = "balanced"
export const TEXT_REFINEMENT_TONE_WARMER = "warmer"
export const TEXT_REFINEMENT_TONE_FRIENDLIER = "friendlier"
export const TEXT_REFINEMENT_TONE_ELABORATE = "elaborate"
export const TEXT_REFINEMENT_TONE_MORE_PROFESSIONAL = "more_professional"
export const TEXT_REFINEMENT_TONE_ASPIRATIONAL = "aspirational"

export const TEXT_REFINEMENT_LENGTH_70_CHAR = "max length 70 characters"
export const TEXT_REFINEMENT_LENGTH_160_CHAR = "max length 160 characters"
